export const CROSS_BORDER_COMPLIANCE_USER_MESSAGE =
  'A Compliance issue has been detected with your request. This may just be a false alarm. A member of our compliance team will reach out to you within 2 hours.';

export function getCrossBorderQuoteId(quote) {
  if (!quote) return null;
  return quote.id ?? quote.Id ?? quote.quoteId ?? quote.QuoteId ?? null;
}

export function buildCrossBorderExecutePayload(quote, requestId) {
  const quoteId = getCrossBorderQuoteId(quote);
  if (!quoteId || !requestId) return null;
  return { requestId, quoteId };
}

export function isCrossBorderQuoteExpired(quote) {
  const expiry = quote?.expiry ?? quote?.Expiry;
  if (!expiry) return false;
  return new Date(expiry).getTime() <= Date.now();
}

export function isDuplicateExecuteError(error) {
  const detail = String(error?.detail || error?.message || error?.title || '').trim();
  return /idempotency|already been processed|duplicate request/i.test(detail);
}

export function isComplianceException(errorOrText) {
  if (errorOrText == null) return false;

  if (typeof errorOrText === 'string') {
    return /complianceexception|compliance\s*blocked|pep\/?sanctions|adverse media|compliance (check |issue|hit)/i.test(
      errorOrText,
    );
  }

  const title = String(errorOrText?.title || errorOrText?.Title || '').trim();
  const detail = String(errorOrText?.detail || errorOrText?.Detail || errorOrText?.message || errorOrText?.errorMessage || '').trim();
  const type = String(errorOrText?.type || errorOrText?.Type || '').trim();

  if (/complianceexception/i.test(title) || /complianceexception/i.test(type)) {
    return true;
  }

  return isComplianceException(`${title} ${detail}`);
}

export function getCrossBorderExecuteErrorMessage(error) {
  if (isComplianceException(error)) {
    return CROSS_BORDER_COMPLIANCE_USER_MESSAGE;
  }

  const detail = String(error?.detail || error?.message || '').trim();

  if (/incorrect fee/i.test(detail)) {
    return 'This quote could not be executed due to a fee mismatch. Please refresh the quote and try again.';
  }
  if (/expired/i.test(detail)) {
    return 'This quote has expired. Please get a new quote and try again.';
  }
  if (/sanitycheckexception/i.test(detail)) {
    return 'This quote is no longer valid. Please get a new quote and try again.';
  }
  if (isDuplicateExecuteError(error)) {
    return 'This transfer was already submitted.';
  }

  return detail || 'Failed to execute transfer. Please try again.';
}

export function getCrossBorderProgressErrorMessage(errorMessage, steps = []) {
  if (isComplianceException(errorMessage)) {
    return CROSS_BORDER_COMPLIANCE_USER_MESSAGE;
  }

  const hasComplianceBlockedStep = (steps || []).some((step) => {
    const id = String(step?.id || step?.step || '').toLowerCase();
    return id === 'complianceblocked';
  });

  if (hasComplianceBlockedStep) {
    return CROSS_BORDER_COMPLIANCE_USER_MESSAGE;
  }

  return errorMessage || 'There was a problem processing your transfer.';
}
